import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'landing',
    pathMatch: 'full',
  },
  {
    path: 'landing',
    loadChildren: async () => (await import('@modules/landing/landing.module')).LandingModule,
  },
  {
    path: 'login',
    loadChildren: async () => (await import('./auth/auth.module')).AuthModule,
    data: { title: 'UGOL.Авторизация' },
  },
  {
    path: 'account',
    canActivate: [AuthGuard],
    loadChildren: async () => (await import('./account/account.module')).AccountModule,
    data: { title: 'UGOL.Личный кабинет' },
  },
  {
    path: 'object-editor',
    canActivate: [AuthGuard],
    loadChildren: async () => (await import('@modules/object-editor/object-editor.module')).ObjectEditorModule,
    data: { title: 'Редактор объектов' },
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard],
})
export class AppRoutingModule {}
